import { useConnections } from '@membranehq/react';
import { useMemo } from 'react';

/**
 * Hook to check if an integration app provider is authenticated.
 * Returns true if a connection exists for the given provider key and is not disconnected.
 */
export function useHasActiveProviderConnection(
  providerKey: string | undefined,
): boolean {
  const { connections } = useConnections();

  return useMemo(() => {
    if (!providerKey) return false;
    const connection = connections.find(
      (conn) => conn.integration?.key === providerKey,
    );
    return !!connection && !connection.disconnected;
  }, [connections, providerKey]);
}
